module.exports = __webpack_public_path__ + "static/media/Group1.d85c8074.png";